const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/sepa-ip-payments/api-factory');
const serviceFactory = require('../resources/sepa-ip-payments/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/sepaippayments/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';
  return app => app
      
      .match((`${p}payment.sepaIpPaymentStatus[{keys:sepaIpStatusBodyEncoded}][{keys:guidStr}][{keys:randomStr}]`), requests =>
        Promise.all(requests.map(({ req, res }) =>
        service.getStatus(req.params.sepaIpStatusBodyEncoded, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
}

module.exports = addRoutes;
